// extracted by mini-css-extract-plugin
export default {"container":"Bienvenidos_container__uK-dl","aparecer":"Bienvenidos_aparecer__+3J8A"};